import React from 'react';
import { connect } from 'react-redux';
import Headline from '../components/atoms/Headline';
import {
  InputOrderFormField,
  InputOrderFormSelect,
  InputOrderFormDateBirthday,
  InputOrderFormDate,
  InputOrderFormHidden,
  InputOrderFormCheckbox,
  InputOrderFormCheckboxSupport,
  InputOrderFormCheckboxDocs,
  InputOrderFormCheckboxTeacher
} from '../components/atoms/InputOrderFormElements';
import { setOrder, resetOrder, setPrivacy, resetPrivacy, setTeacher, resetTeacher } from '../actions/status';
import OrderFormPrivacyCheckbox from '../components/molecules/OrderFormPrivacyCheckbox';
import OrderFormTeacherCheckbox from '../components/molecules/OrderFormTeacherCheckbox';
import { setUpload } from '../actions/status';
import { showNextButton } from '../actions/next';
import uniq from 'lodash/uniq';
var AppConfig = require('../config.json');


class OrderView extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.findConfiguration = this.findConfiguration.bind(this);
    this.handleCheckboxSupport = this.handleCheckboxSupport.bind(this);
    this.handleCheckboxDocuments = this.handleCheckboxDocuments.bind(this);
    
    this.isSupportChecked = this.isSupportChecked.bind(this);
    this.handleCheckboxTeacher = this.handleCheckboxTeacher.bind(this);
    this.handleCheckboxCustomData = this.handleCheckboxCustomData.bind(this);
    this.isAlreadyUploaded = this.isAlreadyUploaded.bind(this);
    this.getValidUntil = this.getValidUntil.bind(this);
    this.addUpload = this.addUpload.bind(this);
    this.checkForm = this.checkForm.bind(this);
    this.privacyClick = this.privacyClick.bind(this);
    this.teacherClick = this.teacherClick.bind(this);
    this.getValue = this.getValue.bind(this);
    this.getValueCustomData = this.getValueCustomData.bind(this);
    this.getCustomDataElement = this.getCustomDataElement.bind(this);
    this.state = { completed: false, support: [], documents:[], teacherdoc: false };
    this.uploadedFiles = [];
    this.customdata = {};
    this.support = [];
    this.documents = [];
  }
  componentWillMount() {
    if (this.props.customer.hasOwnProperty('customdata')) {
      this.customdata = this.props.customer.customdata;
    }
    if (this.props.customdata.length) {
      var itm;
      for (var n = 0; n < this.props.customdata.length; n++) {
        itm = this.props.customdata[n];

        if (!this.customdata.hasOwnProperty(itm.key)) {
          var emptyVal;
          switch (itm.type) {
            case 'checkbox':
              emptyVal = false;
              break;
            default:
              emptyVal = '';
              break;
          }
          this.customdata[itm.key] = emptyVal;
        }
      }
    }
    for (var i = 0; i < this.props.upload.files.length; i++) {
      this.uploadedFiles.push(this.props.upload.files[i].type);
    }
    if(this.props.upload.files.length<1) {
      this.uploadedFiles = [];
    }
    if (this.props.project.teachers && this.uploadedFiles.indexOf("teacherdoc") !== -1) {
        this.setState({'teacherdoc' : true}, this.checkForm);
    }
    
  }

  componentDidMount() {
    var nextLink = AppConfig.links.checkout.url;
    // if (this.props.paymentType === 'sf'
    //   && !this.props.payever.rejected
    //   && !this.props.payever.isError
    //   && !this.props.payever.isNotice
    //   && !this.props.payever.isCancelled
    //   && !this.props.payever.isSuccess
    // ) {
    //   nextLink = AppConfig.links.payever.url;
    // }

      var next =
      {
        link: nextLink,
          label: 'Weiter',
          watch: 'order',
          submitDelay: 300
      };

      this.props.dispatch(
        showNextButton(next)
      );
    // }
    //
    
    var newObj = Object.assign({}, this.props.customer);
    newObj.customdata = null;
    this.setState(newObj, this.checkForm);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.pathname === nextProps.pathname;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.upload.files !== this.props.upload.files) {
      this.checkForm();
    }
    if (prevProps.privacy.isset !== this.props.privacy.isset) {
      this.checkForm();
    }
    if (prevProps.teacher.isset !== this.props.teacher.isset) {
      this.checkForm();
    }
  }

  handleChange(targ, hasError, itemkey) {
    var tmp = {};
    if (targ.name.indexOf('customdata_') === -1) {
      tmp[targ.name] = hasError ? '' : targ.value;
      this.setState(tmp, this.checkForm);
    } else {
      tmp = Object.assign({}, this.customdata);
      tmp[itemkey] = hasError ? '' : targ.value;
      this.customdata = tmp;
      this.checkForm();
    }
  }

  privacyClick(status) {
    if (status) {
      this.props.dispatch(setPrivacy());
    } else {
      this.props.dispatch(resetPrivacy());
    }
  }
  teacherClick(status) {
    if (status) {
      this.props.dispatch(setTeacher());
    } else {
      this.props.dispatch(resetTeacher());
    }
  }

  checkForm() {
    var form = { customdata: {} },
      chk = true;

    if (!this.props.privacy.isset) {
      if (this.state.completed) {
        this.props.dispatch(resetOrder());
        this.setState({ completed: false });
      }
      return;
    }
    if (this.props.project.teachers) {
      if (this.uploadedFiles.indexOf("teacherdoc") === -1 || !this.props.teacher.isset) {
        chk = false;
      }
    }

    for (let i = 0; i < this.state.support.length; i++) {
      if (this.uploadedFiles.indexOf(this.state.support[i]) === -1) {
        chk = false;
        break;
      }
    }

    for (let i = 0; i < this.state.documents.length; i++) {
      if (this.uploadedFiles.indexOf(this.state.documents[i]) === -1) {
        chk = false;
        break;
      }
    }
    
    if (!chk) {
      if (this.state.completed) {
        this.props.dispatch(resetOrder());
        this.setState({ completed: false });
      }
      return;
    }
    chk = true;
    for (var key in this.refs) {
      if (
        this.refs[key].props.hasOwnProperty('required') &&
        this.refs[key].props.required
      ) {
        if (key.indexOf('customdata_') !== -1) {
          if (
            !this.customdata.hasOwnProperty(this.refs[key].props.itemkey) ||
            this.customdata[this.refs[key].props.itemkey] === ''
          ) {
            chk = false;
          }
        } else if (key.indexOf('support_') === -1) {
          if (!this.state.hasOwnProperty(key) || this.state[key] === '') {
            chk = false;
          }
        }
        if (!chk) {
          // if (this.state.completed) {
            this.props.dispatch(resetOrder());
            this.setState({ completed: false });
          // }
          return;
        }
      }
      if (key.indexOf('support_') === -1) {
        if (key.indexOf('customdata_') !== -1) {
          form.customdata[this.refs[key].props.itemkey] = this.customdata[
            this.refs[key].props.itemkey
          ];
        } else {
          form[key] = this.state[key];
        }
      }
    }
    form.support = this.state.support;
    form.documents = this.state.documents;
    form.upload = this.props.upload.files;

    this.setState({ completed: true });
    this.props.dispatch(
      setOrder({
        form: form
      })
    );
  }

  handleSubmit(e) {
    e && e.preventDefault();
    return;
  }

  getValue(field) {
    return this.props.customer[field];
  }

  getValueCustomData(field) {
    return this.props.customer.customdata[field];
  }

  addUpload(file, type, validDate) {
    this.uploadedFiles.push(type);
    this.uploadedFiles = uniq(this.uploadedFiles);

    var upl = [{ file: file, type: type, validDate: validDate }],
      tmp;
    for (var i = 0; i < this.props.upload.files.length; i++) {
      tmp = this.props.upload.files[i];
      if (tmp.type !== type) {
        upl.push(tmp);
      }
    }
    this.props.dispatch(setUpload(upl));
  }
  isSupportChecked(itm) {
    var bundle = this.props.project.data.bundles.find(this.findConfiguration);
    if(bundle !== undefined &&
      bundle.hasOwnProperty('support') &&
      bundle.support !== false &&
      bundle.support.indexOf(itm)!==-1 &&
      itm === "spon"
    ) {
      return true;
    }
    return false;
  }
  handleCheckboxSupport(targ, selected, upload) {
    var sup = [], docs = [],
      upl = [],
      tmp,
      bundle = this.props.project.data.bundles.find(this.findConfiguration);
      
      for (var i = 0; i < bundle.support.length; i++) {
        tmp = bundle.support[i];
        if (tmp === targ) {
          if (selected) {
            sup.push(tmp);
          }
          if (upload) {
            upl.push(tmp);
          }
        } else {
          if (this.state.support.indexOf(tmp) !== -1) {
            sup.push(tmp);
          }
          if (this.uploadedFiles.indexOf(tmp) !== -1) {
            upl.push(tmp);
          }
        }
      }
      //console.warn("uploadedFiles ", upl, sup)
      this.uploadedFiles = upl;
      this.setState({ support: sup }, this.checkForm);
    
  }
  handleCheckboxDocuments(targ, selected, upload) {
    var docs = [],
      upl = [],
      tmp,
      bundle = this.props.project.data.bundles.find(this.findConfiguration);
      for (var i = 0; i < bundle.documents.docs.length; i++) {
        tmp = bundle.documents.docs[i].identifier;
        if (tmp === targ) {
          if (selected) {
            docs.push(tmp);
          }
          if (upload) {
            upl.push(tmp);
          }
        } else {
          if (this.state.documents.indexOf(tmp) !== -1) {
            docs.push(tmp);
          }
          if (this.uploadedFiles.indexOf(tmp) !== -1) {
            upl.push(tmp);
          }
        }
      }
      this.uploadedFiles = upl;
      this.setState({ documents: docs }, this.checkForm);
    
  }
  handleCheckboxTeacher(targ, selected, upload) {

    var upl = [];

    if (!upload || !selected) {
      this.setState({ teacherdoc: false }, this.checkForm);
      return;
    }
    upl.push(targ);
      
    this.uploadedFiles = upl;
    this.setState({ teacherdoc: true }, this.checkForm);
    
  }
  isSelectedSupport(field) {
    return this.props.customer.support.indexOf(field) !== -1;
  }
  isSelectedDocument(field) {
    return this.props.customer.documents.indexOf(field) !== -1;
  }
  isSelectedTeacher(field) {
    var hasUpload = false;
    for (var i = 0; i < this.props.upload.files.length; i++) {
      if(this.props.upload.files[i].type === field) {
        hasUpload = true;
        break;
      }
    }
    return this.props.project.teachers && this.uploadedFiles.indexOf(field) !== -1 && hasUpload;
  }

  isAlreadyUploaded(field) {

    for (let i = 0; i < this.props.upload.files.length; i++) {
      if (
        this.props.upload.files[i].type === field &&
        this.props.upload.files[i].file !== ''
      ) {
        return true;
      }
    }
    return false;
  }
  getValidUntil(field) {
    for (let i = 0; i < this.props.upload.files.length; i++) {
      if (
        this.props.upload.files[i].type === field &&
        this.props.upload.files[i].file !== '' &&
        this.props.upload.files[i].validDate !== ''
      ) {
        return this.props.upload.files[i].validDate;
      }
    }
    return "";
  }

  handleCheckboxCustomData(targ, selected) {
    var obj = Object.assign({}, this.customdata),
      tmp;
    for (var i = 0; i < this.props.customdata.length; i++) {
      tmp = this.props.customdata[i];
      if (tmp.key === targ) {
        if (selected) {
          obj[tmp.key] = true;
        } else {
          obj[tmp.key] = false;
        }
        break;
      }
    }
    this.customdata = obj;
    this.checkForm();
  }
  isSelectedCustomData(field) {
    if (this.customdata.hasOwnProperty(field) !== -1) {
      var ret = this.customdata[field] === true;
      return ret;
    }
    return false;
  }

  correctSelectOptions(opt) {
    return opt.map(function(itm) {
      return { label: itm, value: itm };
    });
  }
  getCustomDataElement(itm, n) {
    switch (itm.type) {
      case 'checkbox':
        return (
          <InputOrderFormCheckbox
            ref={`customdata_${n}`}
            name={`customdata_${n}`}
            itemkey={itm.key}
            label={itm.label}
            selected={this.isSelectedCustomData(itm.key)}
            onClick={this.handleCheckboxCustomData}
          />
        );

      case 'select':
        return (
          <InputOrderFormSelect
            ref={`customdata_${n}`}
            name={`customdata_${n}`}
            itemkey={itm.key}
            label={itm.label}
            value={this.getValueCustomData(itm.key)}
            options={this.correctSelectOptions(itm.options)}
            required={itm.required}
            onChange={this.handleChange}
          />
        );

      case 'date':
        return (
          <InputOrderFormDate
            ref={`customdata_${n}`}
            name={`customdata_${n}`}
            itemkey={itm.key}
            verify="date"
            label={itm.label}
            value={this.getValueCustomData(itm.key)}
            required={itm.required}
            onChange={this.handleChange}
          />
        );

      case 'hidden':
        return (
          <InputOrderFormHidden
            ref={`customdata_${n}`}
            name={`customdata_${n}`}
            itemkey={itm.key}
            value={itm.value}
            onChange={this.handleChange}
          />
        );

      case 'text':
      default:
        return (
          <InputOrderFormField
            ref={`customdata_${n}`}
            name={`customdata_${n}`}
            itemkey={itm.key}
            label={itm.label}
            value={this.getValueCustomData(itm.key)}
            required={itm.required}
            onChange={this.handleChange}
          />
        );
    }
  }
  findConfiguration(bundle) {
    return this.props.bundle.id === bundle.id;
  }

  render() {
    const bundle = this.props.project.data.bundles.find(this.findConfiguration);

    if(bundle !== undefined &&
      bundle.hasOwnProperty('support') &&
      bundle.support !== false &&
      bundle.support.length !== 0
    ) {
      this.support = bundle.support.map((itm, n) => itm.toLowerCase()).filter(itm => ['but','alg2','fv','spon'].indexOf(itm)!==-1);
    }
    if(bundle !== undefined &&
      bundle.hasOwnProperty('documents') &&
      bundle.documents !== false &&
      bundle.documents.active === true
    ) {
      this.documents = bundle.documents;
    }
    return (
      <div className="contentview order">
        <div className="formwrapper">
          <form className="orderform" onSubmit={this.handleSubmit}>
            <div className="personal">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.ordersection.personal
                  .headline}:`}</Headline>
              </div>
              <fieldset name={AppConfig.ordersection.personal.headline}>
                <div className="data">
                  <div className="col col_1">
                    <InputOrderFormSelect
                      label="Anrede"
                      required={true}
                      name="anrede"
                      ref="anrede"
                      value={this.getValue('anrede')}
                      options={AppConfig.selectmenus.anrede}
                      onChange={this.handleChange}
                    />
                    <InputOrderFormField
                      label="Vorname"
                      required={true}
                      name="vorname"
                      ref="vorname"
                      value={this.getValue('vorname')}
                      onChange={this.handleChange}
                    />
                    <InputOrderFormField
                      label="Nachname"
                      required={true}
                      name="nachname"
                      ref="nachname"
                      value={this.getValue('nachname')}
                      onChange={this.handleChange}
                    />
                    {AppConfig.inputoptions.birthdatecustomer &&
                    <InputOrderFormDateBirthday
                      label="Geburtsdatum"
                      required={true}
                      verify="date"
                      name="geburtstag"
                      ref="geburtstag"
                      value={this.getValue('geburtstag')}
                      onChange={this.handleChange}
                    />}
                  </div>
                  <div className="col col_2">
                    <InputOrderFormField
                      label="Strasse"
                      required={true}
                      name="strasse"
                      ref="strasse"
                      value={this.getValue('strasse')}
                      onChange={this.handleChange}
                    />
                    <InputOrderFormField
                      label="Haus-Nr"
                      required={true}
                      name="hausnummer"
                      ref="hausnummer"
                      verify="hausnummer"
                      value={this.getValue('hausnummer')}
                      onChange={this.handleChange}
                    />
                    <InputOrderFormField
                      label="Postleitzahl"
                      required={true}
                      name="plz"
                      ref="plz"
                      verify="number"
                      value={this.getValue('plz')}
                      onChange={this.handleChange}
                    />
                    <InputOrderFormField
                      label="Ort"
                      required={true}
                      name="ort"
                      ref="ort"
                      value={this.getValue('ort')}
                      onChange={this.handleChange}
                    />
                    {this.props.paymentType !== 'sf' &&
                    <InputOrderFormSelect
                      label="Land"
                      required={true}
                      name="land"
                      ref="land"
                      value={this.getValue('land')}
                      options={AppConfig.selectmenus.land}
                      onChange={this.handleChange}
                    />}
                  </div>
                  <div className="col col_3">
                    <InputOrderFormField
                      label="E-Mail Adresse"
                      required={true}
                      type="email"
                      name="email"
                      ref="email"
                      value={this.getValue('email')}
                      verify="email"
                      onChange={this.handleChange}
                    />
                    <InputOrderFormField
                      label="Telefonnummer"
                      required={true}
                      type="tel"
                      name="telefon"
                      ref="telefon"
                      value={this.getValue('telefon')}
                      onChange={this.handleChange}
                    />
                    <InputOrderFormField
                      label="Faxnummer"
                      type="tel"
                      name="fax"
                      ref="fax"
                      value={this.getValue('fax')}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </fieldset>
            </div>


            {/* Name of child */
              !this.props.project.teachers ? (
            
            <div className="child">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.ordersection.child
                  .headline}:`}</Headline>
              </div>
              <fieldset name={AppConfig.ordersection.child.headline}>
                <div className="data">
                  <div className="col col_1">
                    
                    <InputOrderFormField
                      label="Vorname Kind"
                      required={true}
                      name="vornamekind"
                      ref="vornamekind"
                      value={this.getValue('vornamekind')}
                      onChange={this.handleChange}
                    />
                    
                  </div>
                  <div className="col col_2">
                    
                    <InputOrderFormField
                      label="Nachname Kind"
                      required={true}
                      name="nachnamekind"
                      ref="nachnamekind"
                      value={this.getValue('nachnamekind')}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col col_3">
                    <InputOrderFormDateBirthday
                      label="Geburtsdatum Kind"
                      required={false}
                      adult={false}
                      verify="date"
                      name="geburtstagkind"
                      ref="geburtstagkind"
                      value={this.getValue('geburtstagkind')}
                      onChange={this.handleChange}
                    />

                  </div>
                </div>
              </fieldset>
            </div>
            ) : 
              (
            <div className="teacher">
              <div className="header">
                <Headline typeOf="h3">{`${AppConfig.ordersection.teacher
                  .headline}:`}</Headline>
              </div>
              <fieldset name={AppConfig.ordersection.teacher.headline}>
                <div className="data">
                  <div className="col col_1">
                    
                    <InputOrderFormField
                      label="Name der Schule"
                      required={true}
                      name="schoolname"
                      ref="schoolname"
                      value={this.getValue('schoolname')}
                      onChange={this.handleChange}
                    />
                    
                  </div>
                  <div className="col col_2">
                    <InputOrderFormCheckboxTeacher
                        addUpload={this.addUpload}
                        
                        ref="teacherdoc"
                        type="teacherdoc"
                        alreadyUploaded={this.isAlreadyUploaded("teacherdoc")}
                        selected={this.isSelectedTeacher("teacherdoc")}
                        onClick={this.handleCheckboxTeacher}
                      />
                  </div>
                  
                </div>
              </fieldset>
            </div>
              )
            }


            {/* SHOW BANKING ? */

            this.props.paymentType !== 'rg' &&
            this.props.paymentType !== 'vk' &&
            this.props.paymentType !== 'sf' ? (
              <div className="banking">
                <div className="header">
                  <Headline typeOf="h3">{`${AppConfig.ordersection.banking
                    .headline}:`}</Headline>
                </div>
                <fieldset name={AppConfig.ordersection.banking.headline}>
                  <div className="data">
                    <div className="col col_1">
                      <InputOrderFormField
                        label="Kontoinhaber"
                        required={true}
                        name="kontoinhaber"
                        ref="kontoinhaber"
                        value={this.getValue('kontoinhaber')}
                        onChange={this.handleChange}
                      />
                      <InputOrderFormField
                        label="IBAN"
                        required={true}
                        name="iban"
                        ref="iban"
                        verify="iban"
                        value={this.getValue('iban')}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="col col_2">
                      <InputOrderFormField
                        label="Kreditinstitut"
                        required={true}
                        name="bank"
                        ref="bank"
                        value={this.getValue('bank')}
                        onChange={this.handleChange}
                      />
                      
                    </div>
                  </div>
                </fieldset>
              </div>
            ) : null}

            {/* SUPPORT DATA ? */

            this.support.length !== 0 ? (
            // this.props.support.length !== 0 ? (
              <div className="support">
                <div className="header">
                  <Headline typeOf="h3">{`${AppConfig.ordersection.support
                    .headline}:`}</Headline>
                </div>
                <fieldset name={AppConfig.ordersection.support.headline}>
                  <div className="data">
                    {bundle.support.map((itm, n) => (
                      <div className={`col col_${n}`} key={`check_${n}`}>
                        <InputOrderFormCheckboxSupport
                          addUpload={this.addUpload}
                          addValidUntil={itm==='but'?true:false}
                          validUntil={itm==='but'?this.getValidUntil(itm):""}
                          ref={`support_${n}`}
                          type={itm}
                          alreadyUploaded={this.isAlreadyUploaded(itm)}
                          selected={this.isSelectedSupport(itm)}
                          onClick={this.handleCheckboxSupport}
                        />
                      </div>
                    ))}
                  </div>
                </fieldset>
              </div>
            ) : null}

            {/* DOC UPLOAD ? */

            this.documents.length !== 0 ? (
              // this.props.documents.length !== 0 ? (
                <div className="support">
                  <div className="header">
                    <Headline typeOf="h3">{`${AppConfig.ordersection.documents
                      .headline}:`}</Headline>
                  </div>
                  <fieldset name={AppConfig.ordersection.documents.headline}>
                    <div className="data">
                      {bundle.documents.docs.map((itm, n) => (
                        <div className={`col col_${n}`} key={`check_${itm.identifier}`}>
                          <InputOrderFormCheckboxDocs
                            addUpload={this.addUpload}
                            addValidUntil={false}
                            validUntil={""}
                            ref={`documents_${itm.identifier}`}
                            type={itm}
                            alreadyUploaded={this.isAlreadyUploaded(itm.identifier)}
                            selected={this.isSelectedDocument(itm.identifier)}
                            onClick={this.handleCheckboxDocuments}
                          />
                        </div>
                      ))}
                    </div>
                  </fieldset>
                </div>
              ) : null}
            

            {/* CUSTOM DATA FIELDS ? */
            this.props.customdata.length !== 0 ? (
              <div className="customdata">
                <div className="header">
                  <Headline typeOf="h3">{`${AppConfig.ordersection.customdata
                    .headline}:`}</Headline>
                </div>
                <fieldset name={AppConfig.ordersection.customdata.headline}>
                  <div className="data">
                    {this.props.customdata.map((itm, n) => (
                      <div
                        className={`customitem item_${n} type_${itm.type}`}
                        key={`customdata_${n}`}
                      >
                        {this.getCustomDataElement(itm, n)}
                      </div>
                    ))}
                  </div>
                </fieldset>
              </div>
            ) : null}
            <div className="section checkbox">
              <div className="sectioncontent">
                {this.props.project.teachers? (
                <OrderFormTeacherCheckbox onClick={this.teacherClick} />
                ) : null}
                <OrderFormPrivacyCheckbox onClick={this.privacyClick} />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    pathname: state.routing.location.pathname,
    linkTo: state.content.link,
    paymentType: state.status.payment.type,
    bundle: state.status.bundle,
    project: state.status.project,
    payever: state.payever,
    upload: state.status.upload,
    privacy: state.status.privacy,
    teacher: state.status.teacher,
    customdata: state.status.project.data.customdata,
    customer: state.customer
  };
};
const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderView);



// WEBPACK FOOTER //
// ./src/views/OrderView.js